import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Overall opacity of the grain layer, default 0.06 */
  opacity?: number;
}

/**
 * Grain — subtle animated film-grain noise via inline SVG feTurbulence.
 * Zero external assets required.
 */
const Grain: React.FC<Props> = ({ opacity = 0.06 }) => (
  <div style={{ ...overlayBase, opacity }}>
    <style>{`
      @keyframes oot-grain {
        0%, 100% { transform: translate(0, 0); }
        50%       { transform: translate(-2%, 1%); }
      }
    `}</style>
    <svg
      style={{
        width: "100%",
        height: "100%",
        animation: "oot-grain 0.4s steps(2) infinite",
      }}
    >
      <filter id="oot-noise">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.9"
          numOctaves="2"
          stitchTiles="stitch"
        />
      </filter>
      <rect width="100%" height="100%" filter="url(#oot-noise)" />
    </svg>
  </div>
);

export default Grain;
